import React, { useState, useRef, useEffect } from 'react';
import AmountRangePopover from '../../components/AmountRangePopover';
import CurrencyPopover from '../../components/CurrencyPopover';
import StatusPopover from '../../components/StatusPopover';
// import TypePopover from './TypePopover';
import DatePopover from '../../components/DatePopover';
import EditColumnsPopover from '../../components/EditColumnsPopover';
import WithdrawRequestsPage from '../../components/Pages/WithdrawRequestsPage';
import NewPayoutRequest from '../../components/Pages/NewPayoutRequest';
import { API_BASE_URL, QR_BASE_URL } from '../../utils/apiConfig';
import Permission from '../../components/Permission';
import { FaCalendarAlt } from "react-icons/fa";
import { GoClockFill } from "react-icons/go";
import { LuSquareArrowOutUpRight } from "react-icons/lu";


import { QrCode, Eye, X, Copy, ExternalLink, Calendar, DollarSign, Hash, Wallet, User, Clock, CheckCircle, AlertCircle, Send, Plus, ArrowLeft } from 'lucide-react';
import * as XLSX from 'xlsx';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';

const WalletuserId = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [walletData, setWalletData] = useState(location.state?.walletData || null);
    const [walletDataLoading, setWalletDataLoading] = useState(!location.state?.walletData);
    const [copiedAddress, setCopiedAddress] = useState(null);
    const [selectedTab, setSelectedTab] = useState('All');



    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
    });

    const [selectedRows, setSelectedRows] = useState(new Set());
    const [amountPopoverOpen, setAmountPopoverOpen] = useState(false);
    const [amountFilter, setAmountFilter] = useState({ min: 0, max: 100000 });
    const [currencyPopoverOpen, setCurrencyPopoverOpen] = useState(false);
    const [statusPopoverOpen, setStatusPopoverOpen] = useState(false);
    const [typePopoverOpen, setTypePopoverOpen] = useState(false);
    const [datePopoverOpen, setDatePopoverOpen] = useState(false);
    const [editColumnsPopoverOpen, setEditColumnsPopoverOpen] = useState(false);
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState({ id: 'all', name: 'All Currencies', symbol: 'ALL' });
    const [selectedStatus, setSelectedStatus] = useState({ id: '', name: '', color: 'green' });
    const [selectedType, setSelectedType] = useState({ id: '', name: '' });

    const [apiKey, setApiKey] = useState("");
    const [apiSecret, setApiSecret] = useState("");
    const [timer, setTimer] = useState("");
    //   const [userId, setUserId] = useState("");
    const [apiCredentialsLoading, setApiCredentialsLoading] = useState(false);
    const [showTransactionModal, setShowTransactionModal] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);

    // Date picker states
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 7); // Default to 7 days ago
        return date.toISOString().split('T')[0];
    });
    const [toDate, setToDate] = useState(() => {
        const date = new Date();
        return date.toISOString().split('T')[0];
    });



    // Generate date ranges based on preset selection
    const generateDateRange = (preset) => {
        const today = new Date();
        const formatDate = (date) => {
            return date.toISOString().split('T')[0];
        };

        switch (preset) {
            case 'today':
                return {
                    fromDate: formatDate(today),
                    toDate: formatDate(today)
                };

            case 'yesterday':
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                return {
                    fromDate: formatDate(yesterday),
                    toDate: formatDate(yesterday)
                };

            case 'tomorrow':
                const tomorrow = new Date(today);
                tomorrow.setDate(today.getDate() + 1);
                return {
                    fromDate: formatDate(tomorrow),
                    toDate: formatDate(tomorrow)
                };

            case 'thisWeek':
                const startOfWeek = new Date(today);
                startOfWeek.setDate(today.getDate() - today.getDay());
                const endOfWeek = new Date(startOfWeek);
                endOfWeek.setDate(startOfWeek.getDate() + 6);
                return {
                    fromDate: formatDate(startOfWeek),
                    toDate: formatDate(endOfWeek)
                };

            case 'lastWeek':
                const lastWeekStart = new Date(today);
                lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
                const lastWeekEnd = new Date(lastWeekStart);
                lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
                return {
                    fromDate: formatDate(lastWeekStart),
                    toDate: formatDate(lastWeekEnd)
                };

            case 'thisMonth':
                const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                return {
                    fromDate: formatDate(startOfMonth),
                    toDate: formatDate(endOfMonth)
                };

            case 'lastMonth':
                const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
                return {
                    fromDate: formatDate(lastMonthStart),
                    toDate: formatDate(lastMonthEnd)
                };

            case 'thisYear':
                const startOfYear = new Date(today.getFullYear(), 0, 1);
                const endOfYear = new Date(today.getFullYear(), 11, 31);
                return {
                    fromDate: formatDate(startOfYear),
                    toDate: formatDate(endOfYear)
                };

            case 'lastYear':
                const lastYearStart = new Date(today.getFullYear() - 1, 0, 1);
                const lastYearEnd = new Date(today.getFullYear() - 1, 11, 31);
                return {
                    fromDate: formatDate(lastYearStart),
                    toDate: formatDate(lastYearEnd)
                };

            case 'last7Days':
                const last7Days = new Date(today);
                last7Days.setDate(today.getDate() - 7);
                return {
                    fromDate: formatDate(last7Days),
                    toDate: formatDate(today)
                };

            case 'last30Days':
                const last30Days = new Date(today);
                last30Days.setDate(today.getDate() - 30);
                return {
                    fromDate: formatDate(last30Days),
                    toDate: formatDate(today)
                };

            case 'last90Days':
                const last90Days = new Date(today);
                last90Days.setDate(today.getDate() - 90);
                return {
                    fromDate: formatDate(last90Days),
                    toDate: formatDate(today)
                };

            default:
                return {
                    fromDate: '',
                    toDate: ''
                };
        }
    };

    // Initialize date filter with no dates by default
    const getInitialDateFilter = () => {
        return {
            fromDate: '',
            toDate: '',
            preset: ''
        };
    };

    const [dateFilter, setDateFilter] = useState(getInitialDateFilter);
    // Load visible columns from localStorage or use defaults
    const getInitialVisibleColumns = () => {
        try {
            const saved = localStorage.getItem('transactionTableVisibleColumns');
            if (saved) {
                return JSON.parse(saved);
            }
        } catch (error) {
            console.error('Error loading visible columns from localStorage:', error);
        }

        // Default values
        return {
            checkbox: true,
            amount: true,
            currency: true,
            status: true,
            type: true,
            receivingWallet: true,
            sendingWallet: true,
            date: true,
        };
    };

    const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);
    const amountButtonRef = useRef(null);
    const currencyButtonRef = useRef(null);
    const statusButtonRef = useRef(null);
    const typeButtonRef = useRef(null);
    const dateButtonRef = useRef(null);
    const editColumnsButtonRef = useRef(null);

    // Get user data from localStorage
    const getUserDataFromStorage = () => {
        try {
            const storedUserId = localStorage.getItem("userId");
            const storedUserRole = localStorage.getItem("userRole");
            const storedUserEmail = localStorage.getItem("userEmail");
            const storedExpiry = localStorage.getItem("token_expiry");

            if (!storedUserId) {
                console.error("No userId found in localStorage");
                return null;
            }

            // Check if session has expired
            if (storedExpiry && Date.now() > parseInt(storedExpiry)) {
                console.error("Session expired");
                localStorage.clear();
                window.location.href = "#/";
                return null;
            }

            setUserId(storedUserId);
            return storedUserId;
        } catch (error) {
            console.error("Failed to get user data from localStorage:", error);
            return null;
        }
    };

    // Fetch API credentials
    const fetchApiKey = async () => {
        const currentUserId = getUserDataFromStorage();

        if (!currentUserId) {

            return;
        }

        try {
            setApiCredentialsLoading(true);
            // Use the dedicated API credentials endpoint for secure access
            const response = await fetch(
                `${API_BASE_URL}/merchant/${currentUserId}/api-credentials`,
                {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );


            if (!response.ok) {
                throw new Error(
                    `Failed to fetch API key: ${response.status} ${response.statusText}`
                );
            }

            const data = await response.json();

            // Extract API credentials from the dedicated endpoint response
            let foundApiKey = null;
            let foundApiSecret = null;

            // The dedicated endpoint returns data in data.data structure
            if (data && data.data) {
                foundApiKey = data.data.apiKey || null;
                foundApiSecret = data.data.apiSecret || null;
            }

            let hasErrors = false;
            let errorMessages = [];

            if (foundApiKey) {
                setApiKey(foundApiKey);
            } else {
                hasErrors = true;
                errorMessages.push("API Key not found in response");
            }

            if (foundApiSecret) {
                setApiSecret(foundApiSecret);
            } else {
                hasErrors = true;
                errorMessages.push("API Secret not found in response");
            }

            if (data && data.data && data.data.transactionTimer) {
                setTimer(data.data.transactionTimer);
            }

            if (hasErrors) {
                console.error(
                    errorMessages.join(". ") + ". Check the API response structure."
                );

            }
        } catch (error) {
            console.error("Error fetching API credentials:", error);
        } finally {
            setApiCredentialsLoading(false);
        }
    };

    // Generate QR Generator URL
    const generateQRGeneratorUrl = () => {
        const apiKeyEncoded = apiKey ? btoa(apiKey) : "";
        const apiSecretEncoded = apiSecret ? btoa(apiSecret) : "";
        return `${QR_BASE_URL}/qr-generator?api_key=${apiKeyEncoded}&api_secret=${apiSecretEncoded}&timer=${timer}`;
    };

    // Open QR Generator in new tab
    const openQRGenerator = () => {

        if (apiKey && apiSecret) {
            const url = generateQRGeneratorUrl();

            window.open(url, "_blank");
        } else {
            console.error(
                "API credentials not available. API Key:",
                !!apiKey,
                "API Secret:",
                !!apiSecret
            );
            alert("API credentials not available. Please try refreshing the page.");
        }
    };

    // Open transaction details modal
    const openTransactionModal = (transaction) => {
        setSelectedTransaction(transaction);
        setShowTransactionModal(true);
    };

    // Close transaction details modal
    const closeTransactionModal = () => {
        setShowTransactionModal(false);
        setSelectedTransaction(null);
    };

    // Copy text to clipboard
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            // You could add a toast notification here

        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };

    // Format date to DD/MM/YYYY HH:MM:SS
    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'N/A';
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        } catch (error) {
            return 'N/A';
        }
    };

    // Format date to DD/MM/YYYY
    const formatDate = (dateString) => {
        if (!dateString) return '--';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '--';
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (error) {
            return '--';
        }
    };

    // Format time to HH:MM:SS
    const formatTime = (dateString) => {
        if (!dateString) return '--';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '--';
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        } catch (error) {
            return '--';
        }
    };

    // API function to fetch transactions
    const fetchTransactions = async (tabType = 'all', page = 1, limit = 10) => {
        setLoading(true);
        setError(null);

        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                userId: userId,
                sort: "newest",
                filter: "range",
            });

            // Add type parameter only if it's not 'all'
            if (tabType !== 'all') {
                params.append('type', tabType.toLowerCase());
            }

            // Add filters if they exist
            if (amountFilter.min > 0) {
                params.append('minAmount', amountFilter.min.toString());
            }
            if (amountFilter.max < 100000) {
                params.append('maxAmount', amountFilter.max.toString());
            }
            if (selectedCurrency.id !== 'all') {
                params.append('currency', selectedCurrency.id);
            }
            if (selectedStatus?.id && selectedStatus.id.toLowerCase() !== 'all') {
                params.append('status', selectedStatus.id.toLowerCase());
            }
            if (selectedType?.id && selectedType.id !== '') {
                params.append('type', selectedType.id.toLowerCase());
            }
            // Only add date parameters if they have actual values
            if (dateFilter.fromDate && dateFilter.fromDate.trim() !== '') {
                params.append('startDate', dateFilter.fromDate);
            }
            if (dateFilter.toDate && dateFilter.toDate.trim() !== '') {
                params.append('endDate', dateFilter.toDate);
            }

            const response = await fetch(
                `${API_BASE_URL}/dashboard/transactionList?${params.toString()}`,
                {
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success) {
                setTransactions(data.data.docs || []);
                setPagination({
                    page: data.data.page || 1,
                    limit: data.data.limit || 10,
                    total: data.data.total || 0,
                    totalPages: data.data.totalPages || 0
                });
            } else {
                throw new Error(data.error || 'Failed to fetch transactions');
            }
        } catch (err) {
            console.error('Error fetching transactions:', err);
            setError(err.message);
            setTransactions([]);
        } finally {
            setLoading(false);
        }
    };

    // API function to fetch ALL transactions for export (without pagination)
    const fetchAllTransactionsForExport = async (tabType = 'all') => {
        try {
            const params = new URLSearchParams({
                page: '1',
                limit: '10000', // Large limit to get all records
                sort: "newest",
                filter: "range",
            });

            // Add type parameter only if it's not 'all'
            if (tabType !== 'all') {
                params.append('type', tabType.toLowerCase());
            }

            // Add filters if they exist
            if (amountFilter.min > 0) {
                params.append('minAmount', amountFilter.min.toString());
            }
            if (amountFilter.max < 100000) {
                params.append('maxAmount', amountFilter.max.toString());
            }
            if (selectedCurrency.id !== 'all') {
                params.append('currency', selectedCurrency.id);
            }
            if (selectedStatus?.id && selectedStatus.id.toLowerCase() !== 'all') {
                params.append('status', selectedStatus.id.toLowerCase());
            }
            if (selectedType?.id && selectedType.id !== '') {
                params.append('type', selectedType.id.toLowerCase());
            }
            // Only add date parameters if they have actual values
            if (dateFilter.fromDate && dateFilter.fromDate.trim() !== '') {
                params.append('startDate', dateFilter.fromDate);
            }
            if (dateFilter.toDate && dateFilter.toDate.trim() !== '') {
                params.append('endDate', dateFilter.toDate);
            }

            const response = await fetch(
                `${API_BASE_URL}/dashboard/transactionList?${params.toString()}`,
                {
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success) {
                return data.data.docs || [];
            } else {
                throw new Error(data.error || 'Failed to fetch transactions');
            }
        } catch (err) {
            console.error('Error fetching all transactions for export:', err);
            throw err;
        }
    };

    // Fetch transactions when component mounts or tab changes
    useEffect(() => {
        const tabTypeMap = {
            'All': 'all',
            'Deposit': 'deposit',
            //   'Payout': 'payout',
            'Withdrawal': 'withdrawal'
        };

        const apiType = tabTypeMap[selectedTab] || 'all';
        fetchTransactions(apiType);
    }, [selectedTab]);

    // Fetch transactions when filters change
    useEffect(() => {
        const tabTypeMap = {
            'All': 'all',
            'Deposit': 'deposit',
            //   'Payout': 'payout',
            'Withdrawal': 'withdrawal'
        };

        const apiType = tabTypeMap[selectedTab] || 'all';
        fetchTransactions(apiType, pagination.page, pagination.limit);
    }, [amountFilter, selectedCurrency, selectedStatus, selectedType, dateFilter]);

    // Fetch API credentials when component mounts
    useEffect(() => {
        fetchApiKey();
    }, []);

    // Fallback fetch for wallet data when page is accessed directly (no route state)
    useEffect(() => {
        if (walletData) return;
        const fetchWalletData = async () => {
            try {
                setWalletDataLoading(true);
                const response = await fetch(
                    `${API_BASE_URL}/wallet-service-types/list?search=${encodeURIComponent(userId)}&limit=1`,
                    {
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' }
                    }
                );
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                if (data.success && data.data && data.data.length > 0) {
                    setWalletData(data.data[0]);
                }
            } catch (err) {
                console.error('Error fetching wallet data:', err);
            } finally {
                setWalletDataLoading(false);
            }
        };
        fetchWalletData();
    }, [userId]);

    // Helper: copy wallet address with feedback
    const copyWalletAddress = (text, field) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedAddress(field);
            setTimeout(() => setCopiedAddress(null), 2000);
        }).catch(err => console.error('Failed to copy:', err));
    };

    // Helper: get blockchain explorer URL for an address
    const getExplorerUrl = (network, address) => {
        if (network === 'USDT-TRC20') return `https://tronscan.org/#/address/${address}`;
        if (network === 'USDT-ERC20') return `https://etherscan.io/address/${address}`;
        return '#';
    };

    // Helper: calculate total deposit balance across all wallets
    const calculateWalletTotalBalance = (wallets) => {
        if (!wallets || !Array.isArray(wallets)) return 0;
        return wallets.reduce((total, w) => total + (w.totalDepositAmount || 0), 0);
    };

    // Close date picker when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDatePicker && !event.target.closest('.date-picker')) {
                setShowDatePicker(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDatePicker]);

    // Tab configuration with display names and API values
    const tabs = [
        { label: 'Payments', value: 'All' },
        { label: 'Deposits', value: 'Deposit' },
        // { label: 'Payouts', value: 'Payout' },
        { label: 'Withdrawal', value: 'Withdrawal' }
    ];

    // Helper function to format transaction data
    const formatTransaction = (transaction) => {
        const rawAmount = parseFloat(transaction.amount || 0);
        const actualBalance = parseFloat(transaction.actualBalance || 0);
        return {
            id: transaction._id || transaction.id,
            amount: `${transaction.amount || 0}`,
            rawAmount: rawAmount,
            currency: transaction.currencyType || 'USDT TRC20',
            status: transaction.status || 'Pending',
            type: transaction.invoiceNo || 'N/A',
            invoiceNo: transaction.invoiceNo || 'N/A',
            receivingWallet: transaction.walletAddress || 'N/A',
            sendingWallet: transaction.clientId || 'N/A',
            date: new Date(transaction.createdAt || transaction.confirmedAt).toLocaleString(),
            netAmount: transaction.netAmount || 0,
            fee: transaction.fee || 0,
            actualBalance: actualBalance,
            hasActualBalance: transaction.actualBalance !== undefined && transaction.actualBalance !== null,
            transactionId: transaction.transactionId,
            description: transaction.description,
            confirmedAt: transaction.confirmedAt,
            createdAt: transaction.createdAt,
            transactionHash: transaction.transactionHash,
            blockchainTxHash: transaction.blockchainTxHash,
            adminTransferData: transaction.adminTransferData,
            clientWallet: transaction.clientWallet,
            clientName: transaction.firstName,
            clientEmail: transaction.email,
            clientPhone: transaction.phoneNumber,
        };
    };

    // Format transactions for display
    const formattedTransactions = transactions.map(formatTransaction);

    const handleSelectAll = () => {
        if (selectedRows.size === formattedTransactions.length) {
            setSelectedRows(new Set());
        } else {
            setSelectedRows(new Set(formattedTransactions.map(t => t.id)));
        }
    };

    const handleSelectRow = (id) => {
        const newSelected = new Set(selectedRows);
        if (newSelected.has(id)) {
            newSelected.delete(id);
        } else {
            newSelected.add(id);
        }
        setSelectedRows(newSelected);
    };

    const handleAmountFilterClick = () => {
        if (amountButtonRef.current) {
            const rect = amountButtonRef.current.getBoundingClientRect();
            setAmountPopoverOpen(true);
        }
    };

    const handleAmountFilterApply = (filter) => {
        setAmountFilter(filter);
        // Here you would typically filter the transactions based on the amount range

    };

    const handleCurrencyFilterClick = () => {
        if (currencyButtonRef.current) {
            const rect = currencyButtonRef.current.getBoundingClientRect();
            setCurrencyPopoverOpen(true);
        }
    };

    const handleCurrencySelect = (currency) => {
        setSelectedCurrency(currency);
    };

    const handleStatusFilterClick = () => {
        if (statusButtonRef.current) {
            const rect = statusButtonRef.current.getBoundingClientRect();
            setStatusPopoverOpen(true);
        }
    };

    const handleStatusSelect = (status) => {
        setSelectedStatus(status);
        // Here you would typically filter the transactions based on the selected status

    };

    const handleTypeFilterClick = () => {
        if (typeButtonRef.current) {
            const rect = typeButtonRef.current.getBoundingClientRect();
            setTypePopoverOpen(true);
        }
    };

    const handleTypeSelect = (type) => {
        setSelectedType(type);

    };

    const handleDateFilterClick = () => {
        if (dateButtonRef.current) {
            const rect = dateButtonRef.current.getBoundingClientRect();
            setDatePopoverOpen(true);
        }
    };

    const handleDateFilterApply = (filter) => {
        // If preset is selected, generate date range automatically
        if (filter.preset && filter.preset !== 'custom') {
            const dateRange = generateDateRange(filter.preset);
            const updatedFilter = {
                ...filter,
                fromDate: dateRange.fromDate,
                toDate: dateRange.toDate
            };
            setDateFilter(updatedFilter);

        } else {
            setDateFilter(filter);

        }
    };

    const handleEditColumnsClick = () => {
        if (editColumnsButtonRef.current) {
            const rect = editColumnsButtonRef.current.getBoundingClientRect();
            setEditColumnsPopoverOpen(true);
        }
    };

    const handleEditColumnsApply = (newVisibleColumns) => {
        setVisibleColumns(newVisibleColumns);

        // Save to localStorage
        try {
            localStorage.setItem('transactionTableVisibleColumns', JSON.stringify(newVisibleColumns));
        } catch (error) {
            console.error('Error saving visible columns to localStorage:', error);
        }
    };

    // Check if any filters are applied
    const hasActiveFilters = () => {
        return (
            amountFilter.min > 0 ||
            amountFilter.max < 100000 ||
            selectedCurrency.id !== 'all' ||
            (selectedStatus.id && selectedStatus.id !== '') ||
            (selectedType.id && selectedType.id !== '') ||
            dateFilter.fromDate !== '' ||
            dateFilter.toDate !== ''
        );
    };

    // Reset all filters
    const handleResetFilters = () => {
        setAmountFilter({ min: 0, max: 100000 });
        setSelectedCurrency({ id: 'all', name: 'All Currencies', symbol: 'ALL' });
        setSelectedStatus({ id: '', name: '', color: 'green' });
        setSelectedType({ id: '', name: '' });

        // Reset date filter to no dates
        setDateFilter({
            fromDate: '',
            toDate: '',
            preset: ''
        });

        // Reset date picker to default values (last 7 days)
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        setFromDate(sevenDaysAgo.toISOString().split('T')[0]);
        setToDate(new Date().toISOString().split('T')[0]);

        // Refetch data with reset filters
        const tabTypeMap = {
            'All': 'all',
            'Deposit': 'deposit',
            'Payout': 'payout',
            'Withdrawal': 'withdrawal'
        };
        const apiType = tabTypeMap[selectedTab] || 'all';
        fetchTransactions(apiType, 1, pagination.limit);
    };




    const created = formatDateTime(selectedTransaction?.createdAt);
    const updated = formatDateTime(selectedTransaction?.confirmedAt);
    // Reset column visibility to defaults
    const handleResetColumns = () => {
        const defaultColumns = {
            checkbox: true,
            amount: true,
            currency: true,
            status: true,
            type: true,
            receivingWallet: true,
            sendingWallet: true,
            date: true,
        };

        setVisibleColumns(defaultColumns);

        // Save to localStorage
        try {
            localStorage.setItem('transactionTableVisibleColumns', JSON.stringify(defaultColumns));
        } catch (error) {
            console.error('Error saving reset columns to localStorage:', error);
        }
    };

    // Export selected transactions to Excel
    const handleExportSelected = async () => {
        try {
            // Show loading state
            const exportButton = document.querySelector('[title*="Export"]');
            if (exportButton) {
                exportButton.disabled = true;
                exportButton.innerHTML = `
          <svg class="animate-spin w-4 h-4 mr-2 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="hidden sm:inline">Exporting...</span>
        `;
            }

            // Determine tab type for API call
            const tabTypeMap = {
                'All': 'all',
                'Deposit': 'deposit',
                'Payout': 'payout',
                'Withdrawal': 'withdrawal'
            };
            const apiType = tabTypeMap[selectedTab] || 'all';

            // Fetch ALL transactions matching the filters
            const allTransactions = await fetchAllTransactionsForExport(apiType);

            if (!allTransactions || allTransactions.length === 0) {
                alert('No transactions available to export. Please adjust your filters.');
                return;
            }

            // Format all transactions
            const allFormattedTransactions = allTransactions.map(formatTransaction);

            // Determine which transactions to export
            let selectedTransactions;

            if (selectedRows.size === 0) {
                // No checkboxes selected - export all fetched transactions
                selectedTransactions = allFormattedTransactions;
            } else {
                // Export only checked transactions from the fetched data
                selectedTransactions = allFormattedTransactions.filter(transaction =>
                    selectedRows.has(transaction.id)
                );
            }

            // Check if any transactions remain after filtering
            if (selectedTransactions.length === 0) {
                alert('No transactions available to export. Please adjust your filters or select transactions.');
                return;
            }

            // Prepare data for Excel
            const excelData = selectedTransactions.map(transaction => ({
                'Transaction ID': transaction.transactionId || transaction.id,
                'Invoice No': transaction.invoiceNo || 'N/A',
                'Amount': transaction.amount,
                'Currency': transaction.currency,
                'Status': transaction.status,
                'Type': transaction.type,
                'Receiving Wallet': transaction.receivingWallet === "N/A" ? transaction.clientWallet : transaction.receivingWallet,
                'Date': transaction.date,
                'Net Amount': transaction.netAmount,
                'Fee': transaction.fee,
                'Actual Balance': transaction.actualBalance || 'N/A',
                'Description': transaction.description || 'N/A',
                'Client Name': transaction.clientName || 'N/A',
                'Client Email': transaction.clientEmail || 'N/A',
                'Client Phone': transaction.clientPhone || 'N/A'
            }));

            // Create workbook and worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(excelData);

            // Set column widths
            const colWidths = [
                { wch: 25 }, // Transaction ID
                { wch: 20 }, // Invoice No
                { wch: 15 }, // Amount
                { wch: 15 }, // Currency
                { wch: 12 }, // Status
                { wch: 20 }, // Type
                { wch: 35 }, // Receiving Wallet
                { wch: 20 }, // Date
                { wch: 12 }, // Net Amount
                { wch: 10 }, // Fee
                { wch: 15 }, // Actual Balance
                { wch: 25 }, // Description
                { wch: 20 }, // Client Name
                { wch: 25 }, // Client Email
                { wch: 15 }  // Client Phone
            ];
            ws['!cols'] = colWidths;

            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(wb, ws, 'Transactions');

            // Generate filename with date range if applicable
            let filename = `transactions_${selectedTab.toLowerCase()}`;

            // Add date range to filename
            if (dateFilter.fromDate && dateFilter.toDate) {
                filename += `_${dateFilter.fromDate}_to_${dateFilter.toDate}`;
            } else if (dateFilter.fromDate) {
                filename += `_from_${dateFilter.fromDate}`;
            } else if (dateFilter.toDate) {
                filename += `_until_${dateFilter.toDate}`;
            } else {
                const currentDate = new Date().toISOString().split('T')[0];
                filename += `_${currentDate}`;
            }

            filename += `.xlsx`;

            // Save file
            XLSX.writeFile(wb, filename);

            // Show success message
            const exportType = selectedRows.size > 0 ? 'selected' : 'filtered';
            // alert(`Successfully exported ${selectedTransactions.length} ${exportType} transaction(s) to ${filename}`);

        } catch (error) {
            console.error('Export error:', error);
            alert('Failed to export transactions. Please try again.');
        } finally {
            // Restore button state
            const exportButton = document.querySelector('[title*="Export"]');
            if (exportButton) {
                exportButton.disabled = formattedTransactions.length === 0;
                exportButton.innerHTML = `
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
          </svg>
          <span class="hidden sm:inline">Export ${selectedRows.size > 0 ? `(${selectedRows.size})` : ''}</span>
        `;
            }
        }
    };

    const getPopoverPosition = () => {
        if (amountButtonRef.current) {
            const rect = amountButtonRef.current.getBoundingClientRect();
            const isMobile = window.innerWidth < 640;

            return {
                top: rect.bottom + window.scrollY + 8,
                left: isMobile
                    ? Math.max(16, Math.min(rect.left + window.scrollX, window.innerWidth - 320))
                    : rect.left + window.scrollX,
            };
        }
        return { top: 0, left: 0 };
    };



    const getCurrencyPopoverPosition = () => {
        if (currencyButtonRef.current) {
            const rect = currencyButtonRef.current.getBoundingClientRect();
            const isMobile = window.innerWidth < 640;

            return {
                top: rect.bottom + window.scrollY + 8,
                left: isMobile
                    ? Math.max(16, Math.min(rect.left + window.scrollX, window.innerWidth - 200))
                    : rect.left + window.scrollX,
            };
        }
        return { top: 0, left: 0 };
    };

    const getStatusPopoverPosition = () => {
        if (statusButtonRef.current) {
            const rect = statusButtonRef.current.getBoundingClientRect();
            const isMobile = window.innerWidth < 640;

            return {
                top: rect.bottom + window.scrollY + 8,
                left: isMobile
                    ? Math.max(16, Math.min(rect.left + window.scrollX, window.innerWidth - 200))
                    : rect.left + window.scrollX,
            };
        }
        return { top: 0, left: 0 };
    };

    const getTypePopoverPosition = () => {
        if (typeButtonRef.current) {
            const rect = typeButtonRef.current.getBoundingClientRect();
            const isMobile = window.innerWidth < 640;

            return {
                top: rect.bottom + window.scrollY + 8,
                left: isMobile
                    ? Math.max(16, Math.min(rect.left + window.scrollX, window.innerWidth - 200))
                    : rect.left + window.scrollX,
            };
        }
        return { top: 0, left: 0 };
    };

    const getDatePopoverPosition = () => {
        if (dateButtonRef.current) {
            const rect = dateButtonRef.current.getBoundingClientRect();
            const isMobile = window.innerWidth < 640;
            const popoverWidth = isMobile ? 300 : 320;

            // Calculate the left position to center the popover under the Date column
            let leftPosition = rect.left + window.scrollX;

            // On mobile, ensure it doesn't go off screen
            if (isMobile) {
                leftPosition = Math.max(16, Math.min(leftPosition, window.innerWidth - popoverWidth));
            } else {
                // On desktop, center it under the Date column
                leftPosition = rect.left + window.scrollX - (popoverWidth - rect.width) / 2;
                // Ensure it doesn't go off screen
                leftPosition = Math.max(16, Math.min(leftPosition, window.innerWidth - popoverWidth));
            }

            return {
                top: rect.bottom + window.scrollY + 8,
                left: leftPosition,
            };
        }
        return { top: 0, left: 0 };
    };

    const getEditColumnsPopoverPosition = () => {
        if (editColumnsButtonRef.current) {
            const rect = editColumnsButtonRef.current.getBoundingClientRect();
            const isMobile = window.innerWidth < 640;
            const popoverWidth = 256;

            // Calculate the left position to center the popover under the Edit columns button
            let leftPosition = rect.left + window.scrollX;

            // On mobile, ensure it doesn't go off screen
            if (isMobile) {
                leftPosition = Math.max(16, Math.min(leftPosition, window.innerWidth - popoverWidth));
            } else {
                // On desktop, center it under the Edit columns button
                leftPosition = rect.left + window.scrollX - (popoverWidth - rect.width) / 2;
                // Ensure it doesn't go off screen
                leftPosition = Math.max(16, Math.min(leftPosition, window.innerWidth - popoverWidth));
            }

            return {
                top: rect.bottom + window.scrollY + 8,
                left: leftPosition,
            };
        }
        return { top: 0, left: 0 };
    };

    return (
        <div className="space-y-4 lg:space-y-6 pt-5 sm:pt-8 md:pt-3">
            {/* Back Button + Page Header */}
            <div className="flex flex-col gap-1 mb-6">
                <button
                    onClick={() => navigate('/New-Dashboard/wallet')}
                    className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors mb-3 w-fit"
                >
                    <ArrowLeft className="w-4 h-4" />
                    {t('Wallets.backToWallets')}
                </button>
                <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">
                    {walletData?.userInfo?.fullName || userId}
                </h1>
                <p className="text-sm sm:text-base text-gray-600">
                    {t('Wallets.walletDetailPageSubtitle')} {userId}
                </p>
            </div>

            {/* User Details Card */}
            {walletDataLoading ? (
                <div className="bg-white rounded-2xl p-4 sm:p-6 mb-6 shadow-sm animate-pulse">
                    <div className="h-5 bg-gray-200 rounded w-32 mb-4"></div>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                        {[...Array(4)].map((_, i) => (
                            <div key={i}>
                                <div className="h-3 bg-gray-200 rounded w-16 mb-2"></div>
                                <div className="h-4 bg-gray-200 rounded w-24"></div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : walletData && (
                <div className="bg-white rounded-2xl p-4 sm:p-6 mb-6 shadow-sm">
                    <h3 className="text-base font-semibold text-gray-900 mb-4">{t('Wallets.userDetails')}</h3>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                        <div>
                            <p className="text-xs text-gray-500 mb-1">{t('Wallets.name')}</p>
                            <p className="text-sm font-medium text-gray-900">{walletData.userInfo?.fullName || '--'}</p>
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 mb-1">{t('Wallets.email')}</p>
                            <p className="text-sm font-medium text-gray-900 truncate">{walletData.userInfo?.email || '--'}</p>
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 mb-1">{t('Wallets.phone')}</p>
                            <p className="text-sm font-medium text-gray-900">{walletData.userInfo?.phone || '--'}</p>
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 mb-1">{t('Wallets.status')}</p>
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${walletData.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                {walletData.isActive ? t('Wallets.active') : t('Wallets.inactive')}
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {/* Wallet Cards with QR Codes */}
            {walletDataLoading ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    {[...Array(2)].map((_, i) => (
                        <div key={i} className="bg-white rounded-2xl p-5 shadow-sm animate-pulse">
                            <div className="flex gap-4">
                                <div className="w-20 h-20 bg-gray-200 rounded-lg flex-shrink-0"></div>
                                <div className="flex-1">
                                    <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
                                    <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
                                    <div className="h-8 bg-gray-200 rounded w-32"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : walletData?.wallets && walletData.wallets.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    {walletData.wallets.map((wallet, index) => (
                        <div key={index} className="bg-white rounded-2xl p-5 shadow-sm">
                            {/* Card Header */}
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex items-center gap-2">
                                    <span className="inline-flex px-3 py-1 text-sm font-medium bg-blue-100 text-blue-800 rounded-full">
                                        {wallet.walletNetwork}
                                    </span>
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${wallet.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                        {wallet.isActive ? t('Wallets.active') : t('Wallets.inactive')}
                                    </span>
                                </div>
                                <button
                                    onClick={() => window.open(getExplorerUrl(wallet.walletNetwork, wallet.walletAddress), '_blank')}
                                    className="inline-flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-medium rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all"
                                >
                                    <ExternalLink size={12} />
                                    <span>{t('Wallets.explorer')}</span>
                                </button>
                            </div>

                            {/* QR Code + Address */}
                            <div className="flex gap-4 mb-4">
                                <div className="flex-shrink-0 bg-white border border-gray-200 rounded-lg p-2">
                                    <QRCodeSVG value={wallet.walletAddress || ''} size={80} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-xs text-gray-500 mb-1">{t('Wallets.walletAddress')}</p>
                                    <p className="text-xs font-mono text-gray-900 break-all mb-2">{wallet.walletAddress}</p>
                                    <button
                                        onClick={() => copyWalletAddress(wallet.walletAddress, `wallet-${index}`)}
                                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-lg text-xs font-medium text-gray-700 transition-colors"
                                    >
                                        {copiedAddress === `wallet-${index}` ? (
                                            <>
                                                <CheckCircle className="w-3.5 h-3.5 text-green-500" />
                                                {t('Wallets.copied')}
                                            </>
                                        ) : (
                                            <>
                                                <Copy className="w-3.5 h-3.5" />
                                                {t('Wallets.copyAddress')}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Wallet Stats */}
                            <div className="grid grid-cols-3 gap-3 pt-3 border-t border-gray-100">
                                <div className="text-center">
                                    <p className="text-xs text-gray-500 mb-1">{t('Wallets.totalDeposits')}</p>
                                    <p className="text-sm font-semibold text-gray-900">${wallet.totalDepositAmount || 0}</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-xs text-gray-500 mb-1">{t('Wallets.depositCount')}</p>
                                    <p className="text-sm font-semibold text-gray-900">{wallet.totalDeposits || 0}</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-xs text-gray-500 mb-1">{t('Wallets.lastDeposit')}</p>
                                    <p className="text-sm font-semibold text-gray-900">${wallet.lastDepositAmount || 0}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Transaction History Section Header */}
            <div className="mb-2">
                <h2 className="text-lg font-semibold text-gray-900">{t('Wallets.getTransaction')}</h2>
            </div>

            {/* Transaction Tabs and Filters */}
            <div className="flex flex-col md:flex-row md:justify-between md:items-end gap-4">
                {/* Filters Section - Top on mobile, right on desktop */}
                <div className="flex flex-row items-center gap-2 md:order-2">
                    {/* Reset Filters Button - Can wrap if needed */}
                    {hasActiveFilters() && (
                        <button
                            onClick={handleResetFilters}
                            className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 border border-red-300 rounded-lg font-medium text-red-700 hover:bg-red-50 transition-colors text-xs sm:text-sm whitespace-nowrap"
                        >
                            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                            <span className="hidden sm:inline">Reset</span>
                        </button>
                    )}

                    {/* Date Range Picker, Export, and Columns - Always in one row */}
                    <div className="flex flex-row items-center gap-2 flex-nowrap">
                        <div className="relative date-picker">
                            <button
                                onClick={() => setShowDatePicker(!showDatePicker)}
                                className="flex items-center gap-2 px-2 sm:px-3 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors text-xs sm:text-sm whitespace-nowrap"
                            >
                                <svg
                                    className="w-4 h-4 flex-shrink-0"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    />
                                </svg>
                                <span className="whitespace-nowrap hidden sm:inline">
                                    {new Date(fromDate).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric",
                                    })}{" "}
                                    -{" "}
                                    {new Date(toDate).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric",
                                    })}
                                </span>
                                <span className="whitespace-nowrap sm:hidden">
                                    {new Date(fromDate).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric",
                                    })}
                                </span>
                            </button>


                            {showDatePicker && (
                                <div
                                    className="
      absolute 
      mt-2 
      w-72 sm:w-80 lg:w-80 
      bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-4 
      left-1/2 -translate-x-1/3 sm:left-auto sm:translate-x-0 sm:right-0
    "
                                >
                                    <div className="space-y-4">
                                        <h3 className="text-sm font-semibold text-gray-900">
                                            Select Date Range
                                        </h3>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    From Date
                                                </label>
                                                <input
                                                    type="date"
                                                    value={fromDate}
                                                    onChange={(e) => setFromDate(e.target.value)}
                                                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    To Date
                                                </label>
                                                <input
                                                    type="date"
                                                    value={toDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                        </div>

                                        <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
                                            <button
                                                onClick={() => setShowDatePicker(false)}
                                                className="w-full sm:w-auto px-3 py-2 text-xs text-gray-600 hover:text-gray-800 transition-colors border border-gray-300 rounded-lg"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={() => {
                                                    if (fromDate && toDate) {
                                                        // Update the dateFilter state which will trigger the useEffect to fetch transactions
                                                        setDateFilter({
                                                            fromDate: fromDate,
                                                            toDate: toDate,
                                                            preset: 'custom'
                                                        });
                                                    }
                                                    setShowDatePicker(false);
                                                }}
                                                disabled={!fromDate || !toDate}
                                                className="w-full sm:w-auto px-3 py-2 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Export Button */}
                        <button
                            onClick={handleExportSelected}
                            disabled={formattedTransactions.length === 0}
                            className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 border border-gray-300 rounded-lg font-medium transition-colors text-xs sm:text-sm whitespace-nowrap ${formattedTransactions.length === 0
                                ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
                                : 'text-gray-700 hover:bg-gray-50'
                                }`}
                            title={selectedRows.size > 0 ? `Export ${selectedRows.size} selected transaction(s)` : 'Export all filtered transactions'}
                        >
                            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                            </svg>
                            <span className="hidden sm:inline">
                                Export {selectedRows.size > 0 ? `(${selectedRows.size})` : ''}
                            </span>
                        </button>

                        {/* Edit Columns Button */}
                        <div className="relative">
                            <button
                                ref={editColumnsButtonRef}
                                onClick={handleEditColumnsClick}
                                className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors text-xs sm:text-sm whitespace-nowrap"
                            >
                                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span className="hidden sm:inline">columns</span>
                            </button>

                            {/* Edit Columns Popover */}
                            <EditColumnsPopover
                                isOpen={editColumnsPopoverOpen}
                                onClose={() => setEditColumnsPopoverOpen(false)}
                                onApply={handleEditColumnsApply}
                                position={getEditColumnsPopoverPosition()}
                                visibleColumns={visibleColumns}
                                onResetColumns={handleResetColumns}
                            />
                        </div>
                    </div>
                </div>

                {/* Tabs Section - Bottom on mobile, left on desktop */}
                <div className="flex space-x-4 sm:space-x-8 overflow-x-auto border-b border-gray-200 md:w-4/5 md:order-1">
                    {tabs.map((tab) => (
                        <button
                            key={tab.value}
                            onClick={() => setSelectedTab(tab.value)}
                            className={`pb-3 font-medium text-sm transition-colors whitespace-nowrap ${selectedTab === tab.value
                                ? 'text-[#348BED] border-b-2 border-[#348BED]'
                                : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Selection Counter */}
            {selectedRows.size > 0 && (
                <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span className="text-sm font-medium text-blue-800">
                                {selectedRows.size} transaction{selectedRows.size !== 1 ? 's' : ''} selected
                            </span>
                        </div>
                        <button
                            onClick={() => setSelectedRows(new Set())}
                            className="text-xs text-blue-600 hover:text-blue-800 transition-colors"
                        >
                            Clear selection
                        </button>
                    </div>
                </div>
            )}

            {/* Transaction Table */}
            <div className="bg-white rounded-[25px] p-2 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-[800px] ">
                        <thead className="bg-white border-b border-gray-200">
                            <tr>
                                <th className="px-3 sm:px-6 py-3 text-left">
                                    <input
                                        type="checkbox"
                                        checked={selectedRows.size === transactions.length}
                                        onChange={handleSelectAll}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                </th>
                                {visibleColumns.amount && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 capitalize tracking-wider"
                                        style={{ fontSize: "14px", textTransform: "capitalize" }}
                                    >
                                        <div className="relative">
                                            <button
                                                ref={amountButtonRef}
                                                onClick={handleAmountFilterClick}
                                                className={`flex items-center gap-1 hover:text-gray-700 transition-colors ${amountFilter.min > 0 || amountFilter.max < 100000 ? 'text-blue-600 font-semibold' : ''
                                                    }`}
                                            >
                                                Amount
                                                {/* {(amountFilter.min > 0 || amountFilter.max < 100000) && (
                          <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        )} */}
                                                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </button>

                                            {/* Amount Range Popover */}
                                            <AmountRangePopover
                                                isOpen={amountPopoverOpen}
                                                onClose={() => setAmountPopoverOpen(false)}
                                                onApply={handleAmountFilterApply}
                                                position={getPopoverPosition()}
                                            />
                                        </div>
                                    </th>
                                )}
                                {visibleColumns.currency && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                                        <div className="relative">
                                            <button
                                                ref={currencyButtonRef}
                                                onClick={handleCurrencyFilterClick}
                                                className={`flex items-center gap-1 hover:text-gray-700 transition-colors ${selectedCurrency.id !== 'all' ? 'text-blue-600 font-semibold' : ''
                                                    }`}
                                            >
                                                Currency
                                                {/* {selectedCurrency.id !== 'usdt-trc20' && (
                          <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        )} */}
                                                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </button>

                                            {/* Currency Selection Popover */}
                                            <CurrencyPopover
                                                isOpen={currencyPopoverOpen}
                                                onClose={() => setCurrencyPopoverOpen(false)}
                                                onSelect={handleCurrencySelect}
                                                position={getCurrencyPopoverPosition()}
                                                selectedCurrency={selectedCurrency}
                                            />
                                        </div>
                                    </th>
                                )}
                                {visibleColumns.status && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                                        <div className="relative">
                                            <button
                                                ref={statusButtonRef}
                                                onClick={handleStatusFilterClick}
                                                className={`flex items-center gap-1 hover:text-gray-700 transition-colors ${selectedStatus.id && selectedStatus.id !== '' ? 'text-blue-600 font-semibold' : ''
                                                    }`}
                                            >
                                                Status
                                                {/* {selectedStatus.id && selectedStatus.id !== '' && (
                          <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        )} */}
                                                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </button>

                                            {/* Status Selection Popover */}
                                            <StatusPopover
                                                isOpen={statusPopoverOpen}
                                                onClose={() => setStatusPopoverOpen(false)}
                                                onSelect={handleStatusSelect}
                                                position={getStatusPopoverPosition()}
                                                selectedStatus={selectedStatus}
                                                selectedTab={selectedTab}
                                            />
                                        </div>
                                    </th>
                                )}
                                {/* {visibleColumns.type && selectedTab === 'All' && (
                  <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 capitalize tracking-wider"
                    style={{ fontSize: "14px", textTransform: "capitalize" }}
                  >
                    <div className="relative">
                      <button
                        ref={typeButtonRef}
                        onClick={handleTypeFilterClick}
                        className={`flex items-center gap-1 hover:text-gray-700 transition-colors whitespace-nowrap`}
                      >
                        Transaction Type

                        <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      <TypePopover
                        isOpen={typePopoverOpen}
                        onClose={() => setTypePopoverOpen(false)}
                        onSelect={handleTypeSelect}
                        position={getTypePopoverPosition()}
                        selectedType={selectedType}
                      />
                    </div>
                  </th>
                )} */}
                                {visibleColumns.receivingWallet && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 capitalize tracking-wider hidden lg:table-cell"
                                        style={{ fontSize: "14px", textTransform: "capitalize" }}
                                    >
                                        Receiving wallet
                                    </th>
                                )}
                                {visibleColumns.transactionId && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 capitalize tracking-wider hidden lg:table-cell"
                                        style={{ fontSize: "14px", textTransform: "capitalize" }}
                                    >
                                        Transaction ID
                                        {/* {selectedTab ==="Payments" ? "Transaction ID" : "Invoice No"}  */}
                                    </th>
                                )}
                                {visibleColumns.transactionId && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 capitalize tracking-wider hidden lg:table-cell"
                                        style={{ fontSize: "14px", textTransform: "capitalize" }}
                                    >
                                        Invoice ID
                                        {/* {selectedTab ==="Payments" ? "Transaction ID" : "Invoice No"}  */}
                                    </th>
                                )}
                                {visibleColumns.date && (
                                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 capitalize tracking-wider"
                                        style={{ fontSize: "14px", textTransform: "capitalize" }}
                                    >
                                        <div className="relative">
                                            <button
                                                ref={dateButtonRef}
                                                onClick={handleDateFilterClick}
                                                className={`flex items-center gap-1 hover:text-gray-700 transition-colors ${dateFilter.fromDate !== '' || dateFilter.toDate !== '' ? 'text-blue-600 font-semibold' : ''
                                                    }`}
                                            >
                                                Date
                                                {(dateFilter.fromDate !== '' || dateFilter.toDate !== '') && (
                                                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                                )}
                                                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </button>

                                            {/* Date Range Popover */}
                                            <DatePopover
                                                isOpen={datePopoverOpen}
                                                onClose={() => setDatePopoverOpen(false)}
                                                onApply={handleDateFilterApply}
                                                position={getDatePopoverPosition()}
                                            />
                                        </div>
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {loading ? (
                                <>
                                    {[...Array(6)].map((_, idx) => (
                                        <tr key={`skeleton-${idx}`} className="animate-pulse">
                                            <td className="px-3 sm:px-6 py-3">
                                                <span className="inline-block w-4 h-4 bg-gray-200 rounded"></span>
                                            </td>
                                            {visibleColumns.amount && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap">
                                                    <span className="inline-block h-4 bg-gray-200 rounded w-20"></span>
                                                </td>
                                            )}
                                            {visibleColumns.currency && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap">
                                                    <span className="inline-block h-4 bg-gray-200 rounded w-24"></span>
                                                </td>
                                            )}
                                            {visibleColumns.status && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap">
                                                    <span className="inline-block h-6 bg-gray-200 rounded-[8px] w-20"></span>
                                                </td>
                                            )}
                                            {visibleColumns.receivingWallet && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap hidden lg:table-cell">
                                                    <span className="inline-block h-4 bg-gray-200 rounded w-40"></span>
                                                </td>
                                            )}
                                            {visibleColumns.transactionId && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap hidden lg:table-cell">
                                                    <span className="inline-block h-4 bg-gray-200 rounded w-40"></span>
                                                </td>
                                            )}
                                            {visibleColumns.invoiceNo && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap hidden lg:table-cell">
                                                    <span className="inline-block h-4 bg-gray-200 rounded w-40"></span>
                                                </td>
                                            )}
                                            {visibleColumns.date && (
                                                <td className="px-3 sm:px-6 py-3 whitespace-nowrap">
                                                    <span className="inline-block h-4 bg-gray-200 rounded w-28"></span>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </>
                            ) : error ? (
                                <tr>
                                    <td colSpan={selectedTab === 'All' ? 7 : 7} className="px-6 py-8 text-center">
                                        <div className="text-red-600">
                                            <svg className="w-12 h-12 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                            </svg>
                                            <p className="text-lg font-medium">Error loading transactions</p>
                                            <p className="text-sm text-gray-500 mt-1">{error}</p>
                                            <button
                                                onClick={() => {
                                                    const tabTypeMap = {
                                                        'All': 'all',
                                                        'Deposit': 'deposit',
                                                        'Payout': 'payout',
                                                        'Withdrawal': 'withdrawal'
                                                    };
                                                    const apiType = tabTypeMap[selectedTab] || 'all';
                                                    fetchTransactions(apiType);
                                                }}
                                                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                                            >
                                                Try Again
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ) : formattedTransactions.length === 0 ? (
                                <tr>
                                    <td colSpan={selectedTab === 'All' ? 8 : 7} className="px-6 py-8 text-center">
                                        <div className="text-gray-500">
                                            <svg className="w-12 h-12 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                            <p className="text-lg font-medium">No transactions found</p>
                                            <p className="text-sm text-gray-400 mt-1">Try adjusting your filters or check back later</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                formattedTransactions.map((transaction) => (
                                    <tr
                                        key={transaction.id}
                                        className="hover:bg-gray-50 cursor-pointer"
                                        onClick={() => openTransactionModal(transaction)}
                                    >
                                        <td className="px-3 sm:px-6 py-3 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.has(transaction.id)}
                                                onChange={() => handleSelectRow(transaction.id)}
                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                                            />
                                        </td>
                                        {visibleColumns.amount && (
                                            <td className="px-3 sm:px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-500">
                                                {transaction.amount}
                                            </td>
                                        )}
                                        {visibleColumns.currency && (
                                            <td className="px-3 sm:px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                                                <span className="hidden sm:inline">{transaction.currency}</span>
                                                <span className="sm:hidden">{transaction.currency.split(' ')[0]}</span>
                                            </td>
                                        )}
                                        {visibleColumns.status && (
                                            <td className="px-3 sm:px-6 py-3 whitespace-nowrap">
                                                <span className={`inline-flex items-center px-2 py-1 rounded-[8px] border text-xs font-medium ${transaction.status === "initiated" ? "bg-blue-100 text-blue-800 border-blue-300" :
                                                    transaction.status === "confirmed" ? "bg-green-100 text-green-800 border-green-300" :
                                                        transaction.status === "completed" ? "bg-green-100 text-green-800 border-green-300" :
                                                            transaction.status === "rejected" ? "bg-red-100 text-red-800 border-red-300" :
                                                                transaction.status === "failed" ? "bg-red-100 text-red-800 border-red-300" :
                                                                    transaction.status === "expired" ? "bg-red-100 text-red-800 border-red-300" :
                                                                        transaction.status === "pending" ? "bg-yellow-100 text-yellow-800 border-yellow-300" :
                                                                            transaction.status === "api_failed" ? "bg-orange-100 text-orange-800 border-orange-300" :
                                                                                "bg-gray-100 text-gray-800 border-gray-300"
                                                    }`}>
                                                    {/* Status Icons */}
                                                    {transaction.status === "confirmed" || transaction.status === "completed" ? (
                                                        <CheckCircle className="w-3 h-3 mr-1" />
                                                    ) : transaction.status === "rejected" || transaction.status === "failed" || transaction.status === "expired" ? (
                                                        <AlertCircle className="w-3 h-3 mr-1" />
                                                    ) : transaction.status === "pending" ? (
                                                        <Clock className="w-3 h-3 mr-1" />
                                                    ) : transaction.status === "initiated" ? (
                                                        <Send className="w-3 h-3 mr-1" />
                                                    ) : transaction.status === "api_failed" ? (
                                                        <AlertCircle className="w-3 h-3 mr-1" />
                                                    ) : null}

                                                    <span className="hidden sm:inline capitalize">{transaction.status}</span>
                                                    <span className="sm:hidden">
                                                        {transaction.status === "confirmed" || transaction.status === "completed" ? "✓" :
                                                            transaction.status === "rejected" || transaction.status === "failed" ? "✗" :
                                                                transaction.status === "pending" ? "⏱" :
                                                                    transaction.status === "initiated" ? "→" :
                                                                        transaction.status[0]?.toUpperCase()}
                                                    </span>
                                                </span>
                                            </td>
                                        )}
                                        {/* {selectedTab === 'All' && (
                      <td className="px-3 sm:px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-500">
                        {selectedType?.name === "" ? "All Types" : selectedType?.name}
                      </td>
                    )} */}
                                        {/* {visibleColumns.type && (
                      <>
                        {transaction?.type === "withdrawal" ? (
                          <td className="px-3 sm:px-6 py-3 text-sm text-gray-500 font-mono">
                            <span className="truncate max-w-[200px] block">{transaction.type || 'N/A'}</span>
                          </td>
                        ) : (
                          <td className="px-3 sm:px-6 py-3 text-sm text-gray-500 font-mono">
                            <span className="truncate max-w-[200px] block">{transaction.type}</span>
                          </td>
                        )}
                      </>
                    )} */}
                                        {visibleColumns.receivingWallet && (
                                            <td className="px-3 sm:px-6 py-3 text-sm text-gray-500 font-mono hidden lg:table-cell">
                                                <span className="truncate max-w-[200px] block">{transaction.receivingWallet === "N/A" ? transaction.clientWallet : transaction.receivingWallet}</span>
                                            </td>
                                        )}
                                        {visibleColumns.transactionId && (
                                            <td className="px-3 sm:px-6 py-3 text-sm text-gray-500 hidden lg:table-cell">
                                                <span className="truncate max-w-[200px] block">{transaction.transactionId ?? "--"}</span>
                                            </td>
                                        )}
                                        {visibleColumns.invoiceNo && (
                                            <td className="px-3 sm:px-6 py-3 text-sm text-gray-500 hidden lg:table-cell">
                                                <span className="truncate max-w-[200px] block">{transaction.invoiceNo ?? transaction?.invoiceNo}</span>
                                            </td>
                                        )}
                                        {visibleColumns.date && (
                                            <td className="px-3 sm:px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                                                <span className="hidden sm:inline">{transaction.date}</span>
                                                <span className="sm:hidden">{transaction.date.split(',')[1]}</span>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}

            </div>
            <div className="bg-gary px-3 sm:px-6 py-3  flex flex-col sm:flex-row items-center justify-between gap-3">
                <div className="text-xs sm:text-sm text-gray-700 order-2 sm:order-1">
                    <span className="hidden sm:inline">
                        Viewing {((pagination.page - 1) * pagination.limit) + 1}-{Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
                    </span>
                    <span className="sm:hidden">
                        {((pagination.page - 1) * pagination.limit) + 1}-{Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total}
                    </span>
                </div>
                <div className="flex items-center gap-2 order-1 sm:order-2">
                    <button
                        onClick={() => {
                            if (pagination.page > 1) {
                                const tabTypeMap = {
                                    'All': 'all',
                                    'Deposit': 'deposit',
                                    'Payout': 'payout',
                                    'Withdrawal': 'withdrawal'
                                };
                                const apiType = tabTypeMap[selectedTab] || 'all';
                                fetchTransactions(apiType, pagination.page - 1, pagination.limit);
                            }
                        }}
                        disabled={pagination.page <= 1}
                        className="px-3 py-1 text-xs sm:text-sm text-gray-500 hover:text-gray-700 border border-gray-300 rounded hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Previous
                    </button>
                    <span className="px-3 py-1 text-xs sm:text-sm text-gray-700">
                        Page {pagination.page} of {pagination.totalPages}
                    </span>
                    <button
                        onClick={() => {
                            if (pagination.page < pagination.totalPages) {
                                const tabTypeMap = {
                                    'All': 'all',
                                    'Deposit': 'deposit',
                                    'Payout': 'payout',
                                    'Withdrawal': 'withdrawal'
                                };
                                const apiType = tabTypeMap[selectedTab] || 'all';
                                fetchTransactions(apiType, pagination.page + 1, pagination.limit);
                            }
                        }}
                        disabled={pagination.page >= pagination.totalPages}
                        className="px-3 py-1 text-xs sm:text-sm text-gray-500 hover:text-gray-700 border border-gray-300 rounded hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Next
                    </button>
                </div>
            </div>
            {/* Withdraw Requests Modal */}
            {showWithdrawModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-lg  max-h-[90vh] overflow-hidden">
                        {/* Modal Header */}
                        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200">
                            <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Payout Requests</h2>

                            <button
                                onClick={() => setShowWithdrawModal(false)}
                                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            {/* <p className="text-gray-600 text-sm md:text-base">
            Submit new Payout requests and track their status
          </p> */}
                        </div>

                        {/* Modal Content */}
                        <div
                            className="overflow-y-auto max-h-[calc(90vh-80px)] p-0"
                            style={{
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}
                        >
                            <style dangerouslySetInnerHTML={{
                                __html: `
                  .modal-content::-webkit-scrollbar {
                    display: none;
                  }
                `
                            }} />
                            <div className="modal-content">
                                <NewPayoutRequest setShowWithdrawModal={setShowWithdrawModal} />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Transaction Details Modal */}
            {showTransactionModal && selectedTransaction && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-[#F6F7F8] rounded-[19px] max-w-xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
                        {/* Modal Header */}
                        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 ">
                            <div className="flex items-center space-x-3">
                                {/* <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                  <Wallet className="w-5 h-5 text-white" />
                </div> */}
                                <div>
                                    <h2 className="text-md sm:text-2xl font-semibold text-gray-900">Transaction details</h2>
                                    <p className="text-sm text-[#667085]">This is the complete transaction information</p>
                                </div>
                            </div>
                            <button
                                onClick={closeTransactionModal}
                                className="p-2 text-gray-400 bg-[#D1D5DB87] rounded-full hover:text-gray-600 hover:bg-white rounded-full transition-colors"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div
                            className="overflow-y-auto max-h-[calc(90vh-120px)] p-4 sm:p-6"
                            style={{
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}
                        >
                            <style dangerouslySetInnerHTML={{
                                __html: `
                  .transaction-modal-content::-webkit-scrollbar {
                    display: none;
                  }
                `
                            }} />
                            <div className="transaction-modal-content">
                                {/* Payment details Section */}
                                <div className="mb-2">
                                    <h3 className="text-md font-medium text-[#1A1C1E] mb-4">Payment details</h3>
                                    <div className="space-y-4 bg-white p-4 rounded-[15px]">
                                        {/* Payment Status */}
                                        <div className="flex items-center justify-between  ">
                                            <span className="text-sm font-small text-[#667085]">Payment</span>
                                            <span
                                                className={`text-sm font-medium capitalize ${{
                                                    initiated: "text-blue-500",
                                                    confirmed: "text-green-500",
                                                    completed: "text-green-600",
                                                    rejected: "text-red-600",
                                                    failed: "text-red-600",
                                                    expired: "text-red-500",
                                                    pending: "text-yellow-500",
                                                    api_failed: "text-orange-500",
                                                }[selectedTransaction.status?.toLowerCase()] || "text-gray-600"
                                                    }`}
                                            >
                                                {selectedTransaction.status || "N/A"}
                                            </span>
                                        </div>

                                        {/* Transaction ID */}
                                        <div className="flex items-center justify-between ">
                                            <span className="text-sm font-medium text-[#667085]">Transaction ID</span>
                                            <div className="flex items-center gap-2">
                                                <span
                                                    className="text-sm font-mono text-gray-900 whitespace-nowrap"
                                                    title={selectedTransaction.transactionId || selectedTransaction.id} // full ID on hover
                                                >
                                                    {(selectedTransaction.transactionId || selectedTransaction.id)
                                                        ? `${(selectedTransaction.transactionId || selectedTransaction.id).slice(0, 6)}....${(selectedTransaction.transactionId || selectedTransaction.id).slice(-6)}`
                                                        : "N/A"}
                                                </span>
                                                <button
                                                    onClick={() => copyToClipboard(selectedTransaction.transactionId || selectedTransaction.id)}
                                                    className="p-1 hover:bg-gray-100 rounded transition-colors"
                                                    title="Copy"
                                                >
                                                    <Copy className="w-4 h-4 text-gray-500" />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Actual amount received */}
                                        <div className="flex items-center justify-between ">
                                            <span className="text-sm font-small text-[#667085]">Actual amount received</span>
                                            <span className="text-sm font-medium text-gray-900">{selectedTransaction.actualBalance || '0'} USDT</span>
                                        </div>
                                        <div className="flex items-center justify-between ">
                                            <span className="text-sm font-small text-[#667085]">Request Amount</span>
                                            <span className="text-sm font-medium text-gray-900">{selectedTransaction.amount || '0'} USDT</span>
                                        </div>




                                        {/* Fee */}
                                        {selectedTransaction.fee && (
                                            <div className="flex items-center justify-between ">
                                                <span className="text-sm font-small text-[#667085]">Fee</span>
                                                <span className="text-sm font-medium text-gray-900">{selectedTransaction.fee} USDT</span>
                                            </div>
                                        )}

                                        {/* Currency Type */}
                                        <div className="flex items-center justify-between">
                                            <span className="text-sm font-medium text-[#667085]">Currency Type</span>
                                            <div className="flex items-center gap-2">
                                                {/* Currency Icon */}
                                                <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-gray-100">
                                                    <img
                                                        src="/TRC.png" // change path as per your project structure
                                                        alt="USDT"
                                                        className="w-6 h-6 object-contain"
                                                    />
                                                </div>

                                                {/* Currency Name */}
                                                <span className="text-sm font-medium text-gray-900">
                                                    {selectedTransaction.currency || "N/A"}
                                                </span>
                                            </div>
                                        </div>


                                        {/* Wallet Address */}
                                        <div className="flex items-center justify-between ">
                                            <span className="text-sm font-small text-[#667085]">Wallet Address</span>
                                            <div className="flex items-center gap-2">
                                                <span
                                                    className="text-sm font-mono text-gray-900 whitespace-nowrap"
                                                    title={
                                                        (selectedTransaction.receivingWallet !== "N/A"
                                                            ? selectedTransaction.receivingWallet
                                                            : selectedTransaction.clientWallet) || "N/A"
                                                    }
                                                >
                                                    {(() => {
                                                        const wallet =
                                                            selectedTransaction.receivingWallet !== "N/A"
                                                                ? selectedTransaction.receivingWallet
                                                                : selectedTransaction.clientWallet;

                                                        return wallet && wallet !== "N/A" && wallet.length > 12
                                                            ? `${wallet.slice(0, 6)}....${wallet.slice(-6)}`
                                                            : wallet || "N/A";
                                                    })()}
                                                </span>

                                                <button
                                                    onClick={() => copyToClipboard(selectedTransaction.receivingWallet !== "N/A" ? selectedTransaction.receivingWallet : selectedTransaction.clientWallet)}
                                                    className="p-1 hover:bg-gray-100 rounded transition-colors"
                                                    title="Copy"
                                                >
                                                    <Copy className="w-4 h-4 text-gray-500" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {selectedTab === "Deposit" && (<>
                                        <div className="space-y-4 bg-white p-4 mt-2 rounded-[15px]">
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm font-medium text-[#1A1C1E]">Payment Status</span>

                                                {(() => {
                                                    const amount = selectedTransaction.rawAmount || 0;
                                                    const actualBalance = selectedTransaction.actualBalance || 0;

                                                    let paymentStatus = "";
                                                    let statusColor = "text-green-600";

                                                    if (selectedTab === "Deposit" && selectedTransaction.hasActualBalance) {
                                                        if (
                                                            ["confirmed", "completed", "approved"].includes(selectedTransaction.status)
                                                        ) {
                                                            if (actualBalance < amount) {
                                                                paymentStatus = "Underpaid";
                                                                statusColor = "text-red-600";
                                                            } else if (actualBalance > amount) {
                                                                paymentStatus = "Overpaid";
                                                                statusColor = "text-yellow-600";
                                                            } else {
                                                                paymentStatus = "Exact Paid";
                                                                statusColor = "text-green-600";
                                                            }
                                                        } else {
                                                            paymentStatus = selectedTransaction.status || "Pending";
                                                            statusColor = "text-gray-600";
                                                        }
                                                    } else {
                                                        paymentStatus = selectedTransaction.status || "Pending";
                                                        statusColor = "text-gray-600";
                                                    }

                                                    // choose icon
                                                    let IconComponent = null;
                                                    switch (selectedTransaction.status) {
                                                        case "confirmed":
                                                        case "completed":
                                                            IconComponent = CheckCircle;
                                                            break;
                                                        case "rejected":
                                                        case "failed":
                                                        case "expired":
                                                        case "api_failed":
                                                            IconComponent = AlertCircle;
                                                            break;
                                                        case "pending":
                                                            IconComponent = Clock;
                                                            break;
                                                        case "initiated":
                                                            IconComponent = Send;
                                                            break;
                                                        default:
                                                            IconComponent = null;
                                                    }

                                                    return (
                                                        <div className={`flex items-center gap-1 text-sm font-medium ${statusColor}`}>
                                                            {IconComponent && <IconComponent className="w-4 h-4" />}
                                                            <span className="capitalize">{paymentStatus}</span>
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>

                                    </>)}
                                </div>



                                {selectedTransaction.status != 'expired' && (

                                    <div className=" bg-white p-4 rounded-[15px]">
                                        {/* Top Row */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            {/* Created At */}
                                            <div className="pr-6 border-r border-gray-200">
                                                <div className="text-sm font-medium text-gray-600 mb-2">Created at</div>
                                                <div className="flex items-center gap-2 text-sm text-gray-900">
                                                    <FaCalendarAlt className="w-4 h-4 text-[#667085BF]" />
                                                    <span>{formatDate(selectedTransaction.createdAt)}</span>
                                                    <GoClockFill className="w-4 h-4 text-[#667085BF]" />
                                                    <span>{formatTime(selectedTransaction.createdAt)}</span>
                                                </div>
                                            </div>

                                            {/* Status Updated At */}
                                            <div className="pl-6">
                                                <div className="text-sm font-medium text-gray-600 mb-2">Status Updated At</div>
                                                <div className="flex items-center gap-2 text-sm text-gray-900">
                                                    <FaCalendarAlt className="w-4 h-4 text-[#667085BF]" />
                                                    <span>{formatDate(selectedTransaction.confirmedAt)}</span>
                                                    <GoClockFill className="w-4 h-4 text-[#667085BF]" />
                                                    <span>{formatTime(selectedTransaction.confirmedAt)}</span>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                )}
                                {selectedTransaction.status != 'expired' && (
                                    <div className="flex items-center justify-between bg-white p-4 rounded-[15px] mt-2 mb-2">
                                        <span className="text-sm font-medium text-[#1A1C1E] flex items-center gap-2">
                                            <FaCalendarAlt className="w-4 h-4 text-blue-500" />
                                            Payment Confirmation
                                        </span>
                                        <div className="flex items-center gap-2 text-sm text-gray-900">
                                            <FaCalendarAlt className="w-4 h-4 text-[#667085BF]" />
                                            <span>{formatDate(selectedTransaction.confirmedAt)}</span>
                                            <span className="text-gray-400">|</span>
                                            <GoClockFill className="w-4 h-4 text-[#667085BF]" />
                                            <span>{formatTime(selectedTransaction.confirmedAt)}</span>
                                        </div>
                                    </div>)}
                                {/* TXN Hash */}
                                <div className='bg-white p-4 rounded-[15px]'>

                                    {(selectedTransaction.transactionHash ||
                                        selectedTransaction.blockchainTxHash ||
                                        selectedTransaction.adminTransferData?.transactionHash) && (
                                            <div className="flex items-center justify-between mb-6  ">
                                                <span className="text-sm font-small text-[#667085]">TXN Hash</span>
                                                <div className="flex items-center gap-2">
                                                    <span
                                                        className="text-sm font-mono text-gray-900 whitespace-nowrap"
                                                        title={
                                                            selectedTransaction.transactionHash ||
                                                            selectedTransaction.blockchainTxHash ||
                                                            selectedTransaction.adminTransferData?.transactionHash ||
                                                            "N/A"
                                                        }
                                                    >
                                                        {(() => {
                                                            const hash =
                                                                selectedTransaction.transactionHash ||
                                                                selectedTransaction.blockchainTxHash ||
                                                                selectedTransaction.adminTransferData?.transactionHash;

                                                            return hash && hash.length > 12
                                                                ? `${hash.slice(0, 6)}....${hash.slice(-6)}`
                                                                : hash || "N/A";
                                                        })()}
                                                    </span>

                                                    {(() => {
                                                        const hash =
                                                            selectedTransaction.transactionHash ||
                                                            selectedTransaction.blockchainTxHash ||
                                                            selectedTransaction.adminTransferData?.transactionHash;

                                                        if (!hash) return null;

                                                        let explorerUrl = "#";
                                                        const currency = selectedTransaction.currency?.toUpperCase();

                                                        if (currency === "USDT-TRC20") {
                                                            explorerUrl = `https://tronscan.org/#/transaction/${hash}`;
                                                        } else if (currency === "USDT-ERC20") {
                                                            explorerUrl = `https://etherscan.io/tx/${hash}`;
                                                        }

                                                        return (
                                                            <button
                                                                onClick={() => window.open(explorerUrl, "_blank", "noopener,noreferrer")}
                                                                className="p-1 hover:bg-gray-100 rounded transition-colors"
                                                                title="View on Explorer"
                                                            >
                                                                <LuSquareArrowOutUpRight className="w-4 h-4 text-blue-500" />
                                                            </button>
                                                        );
                                                    })()}

                                                </div>
                                            </div>
                                        )}

                                    {/* Invoice ID */}
                                    {(selectedTransaction.type || selectedTransaction.invoiceNo) && (
                                        <div className="flex items-center justify-between">
                                            <span className="text-sm font-small text-[#667085]">Invoice ID</span>
                                            <div className="flex items-center gap-2">
                                                <span
                                                    className="text-sm font-mono text-gray-900 whitespace-nowrap"
                                                    title={selectedTransaction.type || selectedTransaction.invoiceNo || 'N/A'}
                                                >
                                                    {(() => {
                                                        const invoice = selectedTransaction.type || selectedTransaction.invoiceNo;
                                                        return invoice && invoice !== 'N/A' && invoice.length > 12
                                                            ? `${invoice.slice(0, 6)}....${invoice.slice(-6)}`
                                                            : invoice || 'N/A';
                                                    })()}
                                                </span>
                                                <button
                                                    onClick={() => copyToClipboard(selectedTransaction.type || selectedTransaction.invoiceNo)}
                                                    className="p-1 hover:bg-gray-100 rounded transition-colors"
                                                    title="Copy"
                                                >
                                                    <Copy className="w-4 h-4 text-gray-500" />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WalletuserId;